import { render } from "./SummaryReport.vue?vue&type=template&id=7a66b8f2"
import script from "./SummaryReport.vue?vue&type=script&lang=js"
export * from "./SummaryReport.vue?vue&type=script&lang=js"

import exportComponent from "/src/Hikarusa.Webapp/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__